import ProflleHeroSection from './Profile_Hero/ProflleHeroSection';
import ProfileIntroSection from './Profile_Intro/ProfileIntroSection';


const Profile = () => {

    const slashes = "/".repeat(25);

    return (
        <>
            <ProflleHeroSection />
            <ProfileIntroSection />
        </>
    )
}

export default Profile
